function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { useSearchkitVariables } from '@searchkit/client';
import PropTypes from 'prop-types';
import usePrevious from '../../../hooks/usePrevious';
var SearchResultItemDefault = function SearchResultItemDefault(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, item.fields.title[0]));
};
var SearchResultHeaderDefault = function SearchResultHeaderDefault(_ref2) {
  var data = _ref2.data;
  return /*#__PURE__*/React.createElement("h2", null, data.results.summary.total, " Results");
};
var SearchResults = function SearchResults(_ref3) {
  var data = _ref3.data,
    renderItem = _ref3.renderItem,
    renderHeader = _ref3.renderHeader,
    _ref3$appendResults = _ref3.appendResults,
    appendResults = _ref3$appendResults === void 0 ? false : _ref3$appendResults,
    _ref3$scrollView = _ref3.scrollView,
    scrollView = _ref3$scrollView === void 0 ? null : _ref3$scrollView;
  var SearchResultItem = renderItem;
  var SearchResultHeader = renderHeader;
  var variables = useSearchkitVariables();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var _useState5 = useState(variables.query),
    _useState6 = _slicedToArray(_useState5, 2),
    previousQuery = _useState6[0],
    setPreviousQuery = _useState6[1];
  var _useState7 = useState(variables.filters),
    _useState8 = _slicedToArray(_useState7, 2),
    previousActiveFilters = _useState8[0],
    setPreviousActiveFilters = _useState8[1];
  var _useState9 = useState(variables.sortBy),
    _useState10 = _slicedToArray(_useState9, 2),
    previousSortBy = _useState10[0],
    setPreviousSortBy = _useState10[1];
  var _useState11 = useState( /*#__PURE__*/React.createElement(React.Fragment, null)),
    _useState12 = _slicedToArray(_useState11, 2),
    searchResultItems = _useState12[0],
    setSearchResultItems = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    currentData = _useState14[0],
    setCurrentData = _useState14[1];
  var previousPage = usePrevious(currentPage);
  var previousItems = usePrevious(items);
  useEffect(function () {
    var _data$results$hits, _data$results$hits$pa;
    if (!data || typeof data.results === 'undefined') {
      return;
    }
    setCurrentPage(((_data$results$hits = data.results.hits) === null || _data$results$hits === void 0 ? void 0 : (_data$results$hits$pa = _data$results$hits.page) === null || _data$results$hits$pa === void 0 ? void 0 : _data$results$hits$pa.pageNumber) || 0);
    setPreviousQuery(variables.query);
    setPreviousSortBy(variables.sortBy);
    setPreviousActiveFilters(variables.filters);
    setCurrentData(JSON.stringify(data));
    if (!appendResults) {
      // Set items directly if not appendResults
      return setItems(_toConsumableArray(data.results.hits.items));
    }
    var currentPageNumber = data.results.hits.page.pageNumber;
    var currentQuery = variables.query;
    var currentFiltersLength = variables.filters.length;
    var newData = JSON.stringify(data);
    var currentSortBy = variables.sortBy;
    var queryChanged = previousQuery !== currentQuery;
    var filtersChanged = previousActiveFilters.length !== currentFiltersLength;
    var sortByChanged = currentSortBy !== previousSortBy;
    var pageChanged = currentPageNumber !== previousPage;
    var dataChanged = currentData !== newData;

    // Determine if we have to reset the results, or should append them to the results
    if (dataChanged && (queryChanged || filtersChanged || pageChanged || sortByChanged)) {
      if (typeof previousItems === 'undefined' || queryChanged || filtersChanged || sortByChanged) {
        // Overwrite data when Query, Filters or SortBy has changed
        setItems(_toConsumableArray(data.results.hits.items));
      } else {
        // Append data if the page has changed and we have previousItems
        setItems([].concat(_toConsumableArray(previousItems), _toConsumableArray(data.results.hits.items)));
      }
    }
  }, [data, appendResults, variables]);

  // Set the search results when items have changed
  useEffect(function () {
    setSearchResultItems(items.map(function (item) {
      return /*#__PURE__*/React.createElement(SearchResultItem, {
        key: item.id,
        item: item
      });
    }));
  }, [items]);

  // Scroll to top on every page.
  useEffect(function () {
    var _data$results$hits2, _data$results$hits2$p;
    if (!data || typeof data.results === 'undefined') {
      return;
    }
    var currentPageNumber = ((_data$results$hits2 = data.results.hits) === null || _data$results$hits2 === void 0 ? void 0 : (_data$results$hits2$p = _data$results$hits2.page) === null || _data$results$hits2$p === void 0 ? void 0 : _data$results$hits2$p.pageNumber) || 0;
    if (appendResults === false && scrollView && scrollView.current && currentPageNumber !== 0) {
      scrollView.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [data, appendResults, scrollView]);
  return /*#__PURE__*/React.createElement("div", {
    className: "SearchResults"
  }, data && /*#__PURE__*/React.createElement(SearchResultHeader, {
    data: data
  }), searchResultItems);
};
SearchResults.defaultProps = {
  renderItem: SearchResultItemDefault,
  renderHeader: SearchResultHeaderDefault,
  appendResults: false,
  scrollView: null
};
SearchResults.propTypes = {
  // its turned off due to complex struxture of the object
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  renderItem: PropTypes.elementType,
  renderHeader: PropTypes.elementType,
  appendResults: PropTypes.bool,
  scrollView: PropTypes.element
};
export default SearchResults;